import React from "react";
import Button from "../Button/Button";
import "./StandardModal.css";

const StandardModal = ({
  show,
  onHide,
  title,
  icon = null,
  size = "md",
  children,
  onSave,
  saveLabel = "Save",
  saveLoading = false,
  saveDisabled = false,
  cancelLabel = "Cancel",
  footer = null,
  backdropClick = true,
}) => {
  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (backdropClick && e.target === e.currentTarget) onHide();
  };

  const modalSizeClass = `standard-modal--${size}`;

  return (
    <div className="standard-modal-overlay" onClick={handleBackdropClick}>
      <div className={`standard-modal ${modalSizeClass}`}>
        <div className="standard-modal__header">
          <div className="standard-modal__title">
            {icon && <span className="standard-modal__icon">{icon}</span>}
            <h5>{title}</h5>
          </div>
          <button
            type="button"
            className="standard-modal__close"
            onClick={onHide}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className="standard-modal__body">{children}</div>

        <div className="standard-modal__footer">
          {footer !== null ? (
            footer
          ) : (
            <>
              {onSave && (
                <Button
                  variant="primary"
                  iconLeft={<i className="fal fa-save" />}
                  isLoading={saveLoading}
                  disabled={saveDisabled}
                  onClick={onSave}
                >
                  {saveLabel}
                </Button>
              )}
              <Button variant="danger" iconLeft={<i className="fal fa-times" />} onClick={onHide}>
                {cancelLabel}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StandardModal;